import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { checkoutClient } from '@chegg/commerce-utils';
var API = /*#__PURE__*/function () {
  function API() {
    _classCallCheck(this, API);
  }
  return _createClass(API, null, [{
    key: "createMop",
    value: function createMop(params) {
      return checkoutClient.methodOfPaymentAPI.createMop(params);
    }
  }, {
    key: "updateMop",
    value: function updateMop(params) {
      return checkoutClient.methodOfPaymentAPI.updateMop(params);
    }
  }, {
    key: "getMop",
    value: function () {
      var _getMop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filters) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return checkoutClient.methodOfPaymentAPI.getMop(filters);
            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getMop(_x) {
        return _getMop.apply(this, arguments);
      }
      return getMop;
    }()
  }]);
}();
export { API as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/api/index.js
// module id = 883
// module chunks = 11